import assets from 'themes/base/assets';
import LOGO from './images/logo.ionos.v2.svg';
// const LOGO = 'https://dcd.ionos.com/assets/resolve/logo';

export default {
  ...assets,
  LOGO,
};
